import { getComponent } from './utils'
import MultiTabLayout from '@/layouts/multi-tab-layout.vue'
import AuthLayout from '@/layouts/auth-layout.vue'
import { get_config } from '@/config'

const config = get_config()

import MainLayout from '@/layouts/main-layout.vue'
import LoginLayout from '@/layouts/login-layout.vue'
import PublicLayout from '@/layouts/public-layout.vue'

const Layout = config.is_multitab ? MultiTabLayout : MainLayout

export const routes = [
  {
    path: '/',
    name: 'index',
    redirect: `/home`,
    children: [
      // Public routes
      {
        path: '/home',
        name: 'home',
        component: () => getComponent(`pages/home.vue`),
        meta: { title: () => 'Welcome', layout: PublicLayout, is_public: true },
      },
      {
        path: '/welcome',
        name: 'welcome',
        component: () => getComponent(`pages/welcome.vue`),
        meta: { title: () => 'Welcome', layout: PublicLayout, is_public: true },
      },
      {
        path: '/product',
        name: 'product',
        component: () => getComponent(`pages/product.vue`),
        meta: { title: () => 'Product', layout: PublicLayout, is_public: true },
      },
      {
        path: '/pricing',
        name: 'pricing',
        component: () => getComponent(`pages/pricing.vue`),
        meta: { title: () => 'Pricing', layout: PublicLayout, is_public: true },
      },
      {
        path: '/signup',
        name: 'auth-signup',
        component: () => getComponent(`pages/signup.vue`),
        meta: { title: () => 'Signup', layout: PublicLayout, is_public: true },
      },
      {
        path: '/login',
        name: 'auth-login',
        component: () => getComponent(`pages/login.vue`),
        meta: { title: () => 'Login', layout: PublicLayout, is_public: true },
      },
      {
        path: '/logout',
        name: 'auth-logout',
        component: () => getComponent(`pages/logout.vue`),
        meta: { title: () => 'Logout', layout: PublicLayout, is_public: true },
      },

      {
        path: '/demo-request',
        name: 'demo-request',
        component: () => getComponent(`pages/demo-request.vue`),
        meta: {
          title: () => 'Demo Request',
          layout: PublicLayout,
          is_public: true,
        },
      },

      // Private routes
      {
        path: '/about',
        name: 'about',
        component: () => getComponent(`pages/about.vue`),
        meta: { title: () => 'About', layout: Layout, is_public: true },
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: `/assistant/list`,
        // component: () => getComponent(`pages/dashboard.vue`),
        meta: { title: () => 'Dashboard', layout: Layout, is_public: false },
      },

      // ASSISTANT ROUTES
      {
        path: '/assistant/list',
        name: 'assistant-list',
        component: () => getComponent(`pages/assistant/assistant-list.vue`),
        meta: { title: () => 'Assistants', layout: Layout, is_public: false },
      },
      {
        path: '/assistant/new',
        name: 'assistant-new',
        component: () => getComponent(`pages/assistant/assistant-new.vue`),
        meta: {
          title: () => `New Assistant`,
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/assistant/:id(\\d+)+/edit',
        name: 'assistant-edit',
        component: () => getComponent(`pages/assistant/assistant-edit.vue`),
        meta: {
          title: () => `Edit Assistant`,
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/assistant/:id(\\d+)+',
        name: 'assistant-details',
        component: () => getComponent(`pages/assistant/assistant-details.vue`),
        meta: {
          title: ({ id }: { id: string }) => `Assistant #${id}`,
          layout: Layout,
          is_public: false,
        },
      },

      // TOOL ROUTES
      {
        path: '/tool/list',
        name: 'tool-list',
        component: () => getComponent(`pages/tool/tool-list.vue`),
        meta: {
          title: () => 'Tools',
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/tool/:id(\\d+)+',
        name: 'tool-details',
        component: () => getComponent(`pages/tool/tool-details.vue`),
        meta: {
          title: ({ id }: { id: string }) => `Tool #${id}`,
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/tool/new',
        name: 'tool-new',
        component: () => getComponent(`pages/tool/tool-new.vue`),
        meta: {
          title: () => `New Tool`,
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/tool/:id(\\d+)+/edit',
        name: 'tool-edit',
        component: () => getComponent(`pages/tool/tool-edit.vue`),
        meta: {
          title: () => `Edit Tool`,
          layout: Layout,
          is_public: false,
        },
      },

      // AUTH ROUTES
      {
        path: '/auth/list',
        name: 'auth-list',
        component: () => getComponent(`pages/auth/auth-list.vue`),
        meta: {
          title: () => 'Auth Methods',
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/auth/:id(\\d+)+',
        name: 'auth-details',
        component: () => getComponent(`pages/auth/auth-details.vue`),
        meta: {
          title: ({ id }: { id: string }) => `Auth Method #${id}`,
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/auth/new',
        name: 'auth-new',
        component: () => getComponent(`pages/auth/auth-new.vue`),
        meta: {
          title: () => `New Auth`,
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/auth/:id(\\d+)+/edit',
        name: 'auth-edit',
        component: () => getComponent(`pages/auth/auth-edit.vue`),
        meta: {
          title: () => `Edit Auth`,
          layout: Layout,
          is_public: false,
        },
      },

      // USER ROUTES
      {
        path: '/user/list',
        name: 'user-list',
        component: () => getComponent(`pages/user/user-list.vue`),
        meta: {
          title: () => 'Users',
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/user/:id(\\d+)+',
        name: 'user-details',
        component: () => getComponent(`pages/user/user-details.vue`),
        meta: {
          title: ({ id }: { id: string }) => `User #${id}`,
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/user/new',
        name: 'user-new',
        component: () => getComponent(`pages/user/user-new.vue`),
        meta: {
          title: () => `New User`,
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/user/:id(\\d+)+/edit',
        name: 'user-edit',
        component: () => getComponent(`pages/user/user-edit.vue`),
        meta: {
          title: () => `Edit User`,
          layout: Layout,
          is_public: false,
        },
      },

      // DATA ROUTES
      {
        path: '/data/list',
        name: 'data-list',
        component: () => getComponent(`pages/data/data-list.vue`),
        meta: {
          title: () => 'Data List',
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/data/:id(\\d+)+',
        name: 'data-details',
        component: () => getComponent(`pages/data/data-details.vue`),
        meta: {
          title: ({ id }: { id: string }) => `Data #${id}`,
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/data/new',
        name: 'data-new',
        component: () => getComponent(`pages/data/data-new.vue`),
        meta: {
          title: () => `New Data`,
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/data/:id(\\d+)+/edit',
        name: 'data-edit',
        component: () => getComponent(`pages/data/data-edit.vue`),
        meta: {
          title: () => `Edit Data`,
          layout: Layout,
          is_public: false,
        },
      },

      // MODEL ROUTES
      {
        path: '/model/list',
        name: 'model-list',
        component: () => getComponent(`pages/model/model-list.vue`),
        meta: {
          title: () => 'Models',
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/model/:id(\\d+)+',
        name: 'model-details',
        component: () => getComponent(`pages/model/model-details.vue`),
        meta: {
          title: ({ id }: { id: string }) => `Model #${id}`,
          layout: Layout,
          is_public: false,
        },
      },

      // ACCOUNT ROUTES
      {
        path: '/usage',
        name: 'usage',
        component: () => getComponent(`pages/usage.vue`),
        meta: {
          title: () => 'Usage',
          layout: Layout,
          is_public: false,
        },
      },
      {
        path: '/billing',
        name: 'billing',
        component: () => getComponent(`pages/billing.vue`),
        meta: {
          title: () => 'Billing',
          layout: Layout,
          is_public: false,
        },
      },
    ],
  },
  // ########################################
  // #            Error Routes              #
  // ########################################
  {
    path: '/:catchAll(.*)',
    component: () => getComponent(`components/errors/404.vue`),
    meta: { transition: 'fade', layout: PublicLayout, is_public: true },
  },
]
